export const PASSWORD_PATTERN = /^(?=.*[a-z])(?=.*[A-Z])(?=.{10,})/;
export const OLD_PASSWORD_PATTERN = /^(?=.*[a-z])(?=.*[A-Z])(?=.{6,})/;
